<template>
  <v-card rounded="lg" outlined class="my-2">
    <v-card-text>
      <div class="d-flex" v-if="title">
        <v-icon v-if="icon" :icon="icon">{{icon}}</v-icon>
        <v-card-title class="text-decoration-underline">{{ title }}</v-card-title>
          <v-card-actions v-if="isCloseIcon" style="margin-left: 791px;">
                <v-btn  text @click="handleCloseButton"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-actions>

      </div>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'VCardComponent',
  data () {
    return {
      isClose: false
    }
  },
  props: {
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    headerIcon: {
      type: String,
      default: null
    },
    isCloseIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    headerIconClick () {
      this.$emit('header-icon-click')
    },
    handleCloseButton () {
      this.isClose = true
      this.$emit('close', this.isClose)
    }
  }
}
</script>
